import { T as TableCellHeight } from '../../../../../index-B0HfjrH_.js';

"use strict";
const pluginVersion = "12.2.1";
const defaultOptions = {
  cellHeight: TableCellHeight.Sm,
  frameIndex: 0,
  showHeader: true,
  showTypeIcons: false,
  sortBy: []
};

export { defaultOptions, pluginVersion };
